import React from 'react';
import {
  Switch, Route, withRouter
} from 'react-router-dom';
import HomePage from 'pages/home';
import NeedHelp from 'pages/Help/NeedHelp';
import AccountSettings from 'pages/AccountSettings';

/* eslint-disable react/prefer-stateless-function */
class App extends React.Component {
  componentDidMount() {
    if (process.env.NODE_ENV === 'production') {
      const script = document.createElement('script');
      script.src = 'https://www.clarity.ms/tag/rfeal04zuo';
      script.async = true;
      document.head.appendChild(script);
    }
  }

  render() {
    return (
      <div>
        <Switch>
          <Route
            exact
            path="/settings"
            component={AccountSettings}
          />
          <Route
            exact
            path="/"
            component={HomePage}
          />
          <Route
            exact
            path="/help"
            component={NeedHelp}
          />
        </Switch>
      </div>
    );
  }
}

export default withRouter(App);
